module.exports = __webpack_public_path__ + "static/LGPrestigeImage-06821e8c7fa46f5cd74961fb45d0f0d6.png";